import React from 'react'
import { Route } from 'react-router'

const Dashboard = React.lazy(() => import('@/modules/dashboard/view/dashboard-grid-view.component'))

const dashboardRoutes = (
  <>
    <Route path='' Component={Dashboard} />
    <Route path='dashboard' Component={Dashboard} />
  </>
)

export default dashboardRoutes
